import { configureStore } from '@reduxjs/toolkit'  
import authSlice from './features/Auth/authSlice' 
import jobSlice from './features/Job/jobSlice'
import applicantSlice from './features/Applicant/applicantSlice'
import registrationSlice from './features/Registration/registrationSlice'
import testSlice from './features/Test/testSlice'
 

export const store = configureStore({
  reducer: { 
    auth: authSlice,
    job:jobSlice,
    applicant:applicantSlice,
    registration:registrationSlice,
    test:testSlice
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch